import { Box, Button, Input, makeStyles } from '@material-ui/core';
import React, { FC, useState } from 'react';
import colorRectangle from 'src/images/colorRectangle.png';
import { ChromePicker } from 'react-color';
import { RootState, useDispatch, useSelector } from 'src/store';
import useComponentVisible from 'src/hooks/useComponentVisible';
import { editBtnBgColor } from 'src/store/modules/buttons';

interface editBtnBgColorProps {
  type: string;
}

const useStyles = makeStyles(() => ({
  root: {
    fontFamily: 'Roboto',
    fontSize: 12
  },
  container: {
    // padding: '0 0.5rem',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  colorContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: '0.5rem',
    alignItems: 'center'
  },

  buttonWrapper: {
    maxWidth: '1.5rem',
    minWidth: '1.5rem',
    maxHeight: '1.5rem',
    minHeight: '1.5rem'
  },
  buttonImage: {
    maxWidth: '1.5rem',
    minWidth: '1.5rem',
    maxHeight: '1.5rem',
    minHeight: '1.5rem'
  },

  boxWrapper: {
    margin: '0 0.5rem',
    display: 'flex',
    justifyContent: 'space-between'
  },
  colorBox: {
    padding: '0.25rem 0.5rem',
    borderRadius: '0.25rem',
    border: '1px solid #D9D9D9',
    textAlign: 'center',

    color: '#000',
    fontFamily: 'Roboto',
    fontSize: '0.75rem',
    fontWeight: 400
  },
  opacityBox: {
    width: '3rem',
    padding: '0.25rem 0.5rem',
    borderRadius: '0.25rem',
    border: '1px solid #D9D9D9',
    textAlign: 'center',

    color: '#000',
    fontFamily: 'Roboto',
    fontSize: '0.75rem',
    fontWeight: 400
  },

  //
  backgroundColor: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  }
}));

const EditBtnBgColor: FC<editBtnBgColorProps> = ({ type }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  var btnBgColorR = useSelector(
    (state: RootState) => state.buttons.btnBgColorR
  );
  var btnBgColorG = useSelector(
    (state: RootState) => state.buttons.btnBgColorG
  );
  var btnBgColorB = useSelector(
    (state: RootState) => state.buttons.btnBgColorB
  );
  var btnBgColorA = useSelector(
    (state: RootState) => state.buttons.btnBgColorA
  );

  const {
    refPicker,
    refButton1,
    refButton2,
    isComponentVisible,
    setIsComponentVisible
  } = useComponentVisible(false);

  const handleColorPicker = () => {
    setIsComponentVisible(!isComponentVisible);
  };

  const handleChangeComplete = c => {
    let newBtnBgColorR = JSON.parse(JSON.stringify(btnBgColorR));
    newBtnBgColorR[type] = c.rgb.r;
    let newBtnBgColorG = JSON.parse(JSON.stringify(btnBgColorG));
    newBtnBgColorG[type] = c.rgb.g;
    let newBtnBgColorB = JSON.parse(JSON.stringify(btnBgColorB));
    newBtnBgColorB[type] = c.rgb.b;
    let newBtnBgColorA = JSON.parse(JSON.stringify(btnBgColorA));
    newBtnBgColorA[type] = c.rgb.a;
    dispatch(
      editBtnBgColor(
        newBtnBgColorR,
        newBtnBgColorG,
        newBtnBgColorB,
        newBtnBgColorA
      )
    );
  };

  function ColorToHex(color) {
    var hexadecimal = color.toString(16);
    return hexadecimal.length == 1 ? '0' + hexadecimal : hexadecimal;
  }
  function ConvertRGBtoHex(red, green, blue) {
    return '#' + ColorToHex(red) + ColorToHex(green) + ColorToHex(blue);
  }

  return (
    <div className={classes.root}>
      <Box className={classes.container}>
        <Box className={classes.colorContainer}>
          <Button
            ref={refButton1}
            onClick={handleColorPicker}
            className={classes.buttonWrapper}
          >
            <img
              alt="color"
              src={colorRectangle}
              className={classes.buttonImage}
            />
          </Button>
          <Button
            ref={refButton2}
            style={{
              maxWidth: '1.25rem',
              minWidth: '1.25rem',
              maxHeight: '1.25rem',
              minHeight: '1.25rem',
              padding: 0
            }}
            onClick={handleColorPicker}
          >
            <div
              style={{
                width: '1.25rem',
                height: '1.25rem',
                backgroundColor: `rgb(${btnBgColorR[type]},${btnBgColorG[type]},${btnBgColorB[type]})`,
                border: `1px solid #D9D9D9`,
                borderRadius: 999
              }}
            />
          </Button>
          <div className={classes.colorBox}>
            {ConvertRGBtoHex(
              btnBgColorR[type],
              btnBgColorG[type],
              btnBgColorB[type]
            ).toUpperCase()}
          </div>
          {/* <Input
            disableUnderline
            style={{
              overflow: 'hidden',
              width: 70,
              fontFamily: 'Roboto',
              fontSize: 12
            }}
            onChange={handleChangeColor}
            value={colorPreview}
          /> */}
        </Box>
        <Box className={classes.colorContainer}>
          <div className={classes.opacityBox}>
            {Math.round(btnBgColorA[type] * 100)}%
          </div>
        </Box>
      </Box>
      {isComponentVisible && (
        <div ref={refPicker} style={{ width: '100%', marginTop: '1rem' }}>
          <ChromePicker
            color={`rgba(${btnBgColorR[type]},${btnBgColorG[type]},${btnBgColorB[type]},${btnBgColorA[type]})`}
            onChange={handleChangeComplete}
            width="100%"
          />
        </div>
      )}
    </div>
  );
};

export default EditBtnBgColor;
